module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_brand1_en.c85b7b78dcd334cb34da6183a66b74a8.png";